import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography } from "@mui/material";
import PanToolIcon from "@mui/icons-material/PanTool";
import { useState, useEffect } from "react";

const ACCENT = "#449095";

// IPv4 singolo oppure subnet CIDR (es. 192.168.7.0/24); ANY = qualsiasi
const IP_OR_CIDR = /^(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)){3}(\/(3[0-2]|[12]?\d))?$/;
const isValidIpValue = (value) => value === "ANY" || IP_OR_CIDR.test(value);

const ChooseIpDialog = ({
  open,
  setOpen,
  handleAddRule,
  initialSrcIp = "ANY",
  initialDestIp = "ANY",
  dettaglio = null,
}) => {
  const [srcIp, setSrcIp] = useState(initialSrcIp);
  const [destIp, setDestIp] = useState(initialDestIp);

  useEffect(() => {
    setSrcIp(initialSrcIp);
    setDestIp(initialDestIp);
  }, [open, initialSrcIp, initialDestIp]);

  const srcError = !isValidIpValue(srcIp);
  const destError = !isValidIpValue(destIp);

  const handleSubmit = () => {
    if (!srcError && !destError) handleAddRule(srcIp, destIp);
  };

  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      maxWidth="sm"
      slotProps={{ paper: { sx: { backgroundColor: "#141414", backgroundImage: "none", border: "1px solid #252525", borderRadius: 2.5 } } }}
    >
      <DialogTitle sx={{ borderBottom: "1px solid #1e1e1e", py: 2 }}>
        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1.5}>
          <PanToolIcon sx={{ color: ACCENT, fontSize: 22 }} />
          <Typography sx={{ fontSize: 17, fontWeight: 700 }}>Add suppression rule</Typography>
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ px: 3, pt: "20px !important", pb: 1 }}>
        {dettaglio && (
          <Box sx={{ mb: 2.5, p: 1.5, borderRadius: 1.5, backgroundColor: "#0f0f0f", border: "1px solid #222" }}>
            <Typography sx={{ fontSize: "0.68rem", fontWeight: 800, letterSpacing: "0.12em", color: ACCENT, mb: 0.5 }}>LOG</Typography>
            <Typography sx={{ fontSize: 13.5, color: "#ddd", wordBreak: "break-word" }}>{dettaglio}</Typography>
          </Box>
        )}

        <Typography sx={{ fontSize: 13, color: "#999", mb: 2 }}>
          The automatic response will be skipped for this log when it matches the source and destination below.
        </Typography>

        <Stack direction="row" spacing={2} alignItems="flex-start">
          <TextField
            label="Source IP"
            size="small"
            fullWidth
            placeholder="ANY, 192.168.1.1, 192.168.1.0/24"
            value={srcIp}
            onChange={(e) => setSrcIp(e.target.value.toUpperCase())}
            error={srcError}
            helperText={srcError ? "Enter an IP, a CIDR range or ANY" : "ANY matches every source"}
          />
          <TextField
            label="Destination IP"
            size="small"
            fullWidth
            placeholder="ANY, 192.168.1.1, 192.168.1.0/24"
            value={destIp}
            onChange={(e) => setDestIp(e.target.value.toUpperCase())}
            error={destError}
            helperText={destError ? "Enter an IP, a CIDR range or ANY" : "ANY matches every destination"}
          />
        </Stack>
      </DialogContent>

      <DialogActions sx={{ borderTop: "1px solid #1e1e1e", px: 3, py: 2 }}>
        <Button
          variant="outlined"
          onClick={() => setOpen(false)}
          sx={{ minWidth: 90, color: "#888", borderColor: "rgba(255,255,255,0.12)", "&:hover": { borderColor: "#666", backgroundColor: "rgba(255,255,255,0.04)", color: "#bbb" } }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={srcError || destError}
          sx={{ minWidth: 110, backgroundColor: ACCENT, "&:hover": { backgroundColor: "#367a7e" }, "&.Mui-disabled": { backgroundColor: "#2a2a2a", color: "#555" } }}
        >
          Add rule
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ChooseIpDialog;
